import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import * as fromRoot from '@app/reducers/index';
import { Store } from '@ngrx/store';
import { Region } from '@smash-sdk/core';
import { DataCenterRegions, matchDataCenter } from '@app/shared/helpers/dataCenterMapper';

@Injectable({
    providedIn: 'root'
})
export class ResolveSendLocalizedMessageService {


    localizedMessageMap: Record<DataCenterRegions, string> = {
        'FR': 'LOCALIZED_MESSAGE_KEYWORD_V2_FR',
        'GB': 'LOCALIZED_MESSAGE_KEYWORD_V2_GB',
        'IE': 'LOCALIZED_MESSAGE_KEYWORD_V2_IE',
        'DE': 'LOCALIZED_MESSAGE_KEYWORD_V2_DE',
        'CA': 'LOCALIZED_MESSAGE_KEYWORD_V2_CA',
        'US_EAST': 'LOCALIZED_MESSAGE_KEYWORD_V2_US_EAST',
        'US_WEST': 'LOCALIZED_MESSAGE_KEYWORD_V2_US_WEST',
        'UE': 'LOCALIZED_MESSAGE_KEYWORD_V2_UE',
    }

    constructor(
        private readonly store$: Store<fromRoot.State>,
    ) { }

    resolve(): Observable<{ keyword: string }> {
        const resolved$ = new ReplaySubject<{ keyword: string; }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getCountryCode),
                this.store$.select(fromRoot.getCurrentRegion),
                this.store$.select(fromRoot.getCurrentDomain),
            ),
            takeUntil(resolved$)
        ).subscribe(([_, userCountry, region, currentDomain]) => {
            if (userCountry && region && currentDomain) {
                const targetRegion = currentDomain.region || region;
                resolved$.next({ keyword: this.localizedMessageMap[matchDataCenter(userCountry, targetRegion as Region).value] });
            }
        });

        return resolved$.asObservable();
    }
}